var map = {
	"./2099.svg": "4c8c",
	"./3d.svg": "1df4",
	"./annihilation.svg": "d585",
	"./antman.svg": "87e3",
	"./blackpanther.svg": "77f1",
	"./blackwidow.svg": "7a47",
	"./captainamerica.svg": "4fb6",
	"./champions.svg": "50e4",
	"./civilwar.svg": "b1a3",
	"./coreset.svg": "1db9",
	"./coreset2.svg": "c117",
	"./darkcity.svg": "5802",
	"./deadpool.svg": "b1d9",
	"./dimensions.svg": "7fd9",
	"./doctorstrange.svg": "6310",
	"./fearitself.svg": "5fed",
	"./ff.svg": "b2eb",
	"./gotg.svg": "29e7",
	"./heroesofasgard.svg": "c8eb",
	"./intothecosmos.svg": "68e2",
	"./marvelstudios.svg": "c2ab",
	"./messiahcomplex.svg": "64ba",
	"./midnightsons.svg": "a8ff",
	"./msaw.svg": "9429",
	"./msgotg.svg": "611a",
	"./msis.svg": "63b9",
	"./mswi.svg": "e5fc",
	"./newmutants.svg": "c4fb",
	"./noir.svg": "b161",
	"./promo.svg": "fd00",
	"./pttr.svg": "62df",
	"./realmofkings.svg": "bacd",
	"./revelations.svg": "a120",
	"./shield.svg": "7c8c",
	"./spiderhomecoming.svg": "a61a",
	"./sw1.svg": "2486",
	"./sw2.svg": "a742",
	"./venom.svg": "801d",
	"./villains.svg": "daf7",
	"./weaponx.svg": "f88e",
	"./wwhulk.svg": "1978",
	"./xmen.svg": "c69d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae82a";